import { useCallback } from 'react';
import { UnitPcvFinantialForm, UnitPcvItemList } from '../models/unitPcv';
import FormModal from '../../../components/modals/FormModal';
import ManageUnitPcvFinantialForm from './ManageUnitPcvFinantialForm';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import {
  createPcvFinantialEndpoint,
  updatePcvFinantialEndpoint,
} from '../services/unitPcvService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

interface Props {
  pcv: UnitPcvItemList;
  isOpen: boolean;
  toggle: () => void;
}

const UnitPcvFinantialModal = ({ pcv, isOpen, toggle }: Props) => {
  const { callEndpoint } = useCallApiAndLoad();
  const navigate = useNavigate();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const isEditing = pcv.finantial !== null;

  const handleForm = useCallback(
    async (form: UnitPcvFinantialForm, errorRepository: Function) => {
      const endpoint = isEditing
        ? updatePcvFinantialEndpoint(pcv.id, form, token)
        : createPcvFinantialEndpoint(pcv.id, form, token);

      const expectedStatus = isEditing ? 200 : 201;

      const { status, data } = await callEndpoint(endpoint);
      const response = fetchResponseAdapter(data);
      if (status === expectedStatus) navigate(0);
      else errorRepository(response.message);
    },
    [],
  );

  const finantialForm = (
    <ManageUnitPcvFinantialForm
      finantial={pcv.finantial ?? undefined}
      handleForm={handleForm}
    />
  );

  return (
    <FormModal
      headerText={isEditing ? 'Editar datos financieros' : 'Crear datos financieros'}
      children={finantialForm}
      isOpen={isOpen}
      onConfirmation={() => {}}
      onReset={() => {}}
      onToggle={toggle}
      size="lg"
      withFooterActions={false}
    />
  );
};

export default UnitPcvFinantialModal;
